import { useCallback, useContext, useMemo } from "react";
import { CopilotMessageContext } from "~/providers/CopilotMessageProvider";
import LadleCard from "./components/ladleCard/LadleCard";
import styles from "./ConversationList.module.less";
import Scrollbars from "react-custom-scrollbars";
import { Select, Skeleton, Tooltip } from "antd";
import { NoDataAvailable } from "~/components/noDataAvailable/NoDataAvailable";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { useLanguage } from "~/hooks/useLanguage";

const MAX_TAG_COUNT = 4;

function ConversationList() {
  const {
    isConversationListExpanded,
    conversationList,
    conversationListLoading,
    filteredLadleIdList,
    ladleFilterOptionList,
    setFilteredLadleIdList,
  } = useContext(CopilotMessageContext);

  const ladleFilterOptionListMemo = useMemo(() => {
    return ladleFilterOptionList?.map((x) => {
      return {
        ...x,
        label: x.label === "-1" ? "Unassigned" : x.label,
      };
    });
  }, [ladleFilterOptionList]);

  const { formatMessage } = useLanguage();

  const onChange = useCallback(
    (value: string[]) => {
      setFilteredLadleIdList(value);
    },
    [setFilteredLadleIdList],
  );

  return (
    <div
      className={`${styles.ConversationList} ${
        isConversationListExpanded ? "" : styles.hidden
      }`}
    >
      <Scrollbars autoHide>
        <div className={styles.wrapper}>
          {conversationListLoading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <Skeleton active key={index} />
            ))
          ) : conversationList?.length == 0 ? (
            <NoDataAvailable
              title={formatMessage("ConversationList.NoDataAvailable")}
            />
          ) : (
            <>
              <Select
                value={filteredLadleIdList}
                onChange={onChange}
                mode="multiple"
                placeholder={formatMessage("ConversationList.LadleFilter")}
                suffixIcon={
                  (filteredLadleIdList?.length ?? 0) ? (
                    <CloseCircleOutlined
                      onClick={(e) => {
                        e.stopPropagation();
                        setFilteredLadleIdList(undefined);
                      }}
                    />
                  ) : (
                    <SearchOutlined />
                  )
                }
                allowClear
                showSearch
                maxTagCount={MAX_TAG_COUNT}
                maxTagPlaceholder={(selecteds) => {
                  return (
                    <Tooltip
                      title={selecteds.map((s) => (
                        <div key={"Tooltip" + s.key}>
                          {conversationList
                            ?.filter((x) => x.assetId === s.value)
                            .map((x) => x.assetName)}
                        </div>
                      ))}
                    >
                      + {(filteredLadleIdList?.length ?? 0) - MAX_TAG_COUNT}...
                    </Tooltip>
                  );
                }}
                options={ladleFilterOptionListMemo}
                optionFilterProp="label"
              />
              {conversationList?.map(
                ({
                  id,
                  destination,
                  location,
                  currentHeatNumber,
                  assetName,
                  state,
                }) => (
                  <LadleCard
                    key={"ladleCard_" + id}
                    id={id}
                    serviceState={state}
                    destination={destination}
                    location={location}
                    currentHeatNumber={currentHeatNumber}
                    laddleAssetName={assetName}
                  />
                ),
              )}
            </>
          )}
        </div>
      </Scrollbars>
    </div>
  );
}

export default ConversationList;
